import {
  patientCounters,
  waitingNumberFromProps,
  pacuNumberFromProps,
  postOpsNumberFromProps,
} from '../../utils/patientCounters';

// Sound imports
import closing from '@/assets/sound/closing.mp3';
import discharge from '@/assets/sound/discharge.mp3';
import holdProcedure from '@/assets/sound/holdProcedure.mp3';
import blockNerve from '@/assets/sound/holdProcedure.mp3'; // change to blockNerve sound
import help from '@/assets/sound/holdProcedure.mp3'; // change to help sound
import orReady from '@/assets/sound/orReady.mp3';
import readyToPickup from '@/assets/sound/readyToPickup.mp3';
import waitingReady from '@/assets/sound/waitingReady.mp3';
import procedureEnd from '@/assets/sound/procedureEnd.mp3';
import { AlertDefinition } from '@/components/pages/kiosk/monitor/hooks/alerts/alerts.types';

/**
 * Central registry of all alert definitions
 * Each alert contains its condition logic, sound file, and configuration flag
 */
export const ALERT_REGISTRY: AlertDefinition[] = [
  {
    id: 'readyForPrepReady',
    soundFile: waitingReady,
    configFlag: 'prepReadySound',
    condition: (current, previous) => waitingNumberFromProps(current) > waitingNumberFromProps(previous),
    description: 'Patient ready for prep in waiting room',
  },
  {
    id: 'readyForOR',
    soundFile: orReady,
    configFlag: 'orReadySound',
    condition: (current, previous) =>
      patientCounters.readyForORNumberFromProps(current) > patientCounters.readyForORNumberFromProps(previous),
    description: 'Patient ready for OR',
  },
  {
    id: 'readyForSurgeon',
    soundFile: waitingReady,
    configFlag: 'readyForSurgeonSound',
    condition: (current, previous) =>
      patientCounters.readyForSurgeonNumberFromProps(current) >
      patientCounters.readyForSurgeonNumberFromProps(previous),
    description: 'Patient ready for surgeon',
  },
  {
    id: 'holdProcedure',
    soundFile: holdProcedure,
    configFlag: 'holdProcedureSound',
    condition: (current, previous) =>
      patientCounters.holdProcedureNumberFromProps(current) > patientCounters.holdProcedureNumberFromProps(previous),
    description: 'Procedure on hold',
  },
  {
    id: 'blockNerve',
    soundFile: blockNerve,
    configFlag: 'blockNerveSound',
    condition: (current, previous) => {
      const currentCount =
        patientCounters.blockNerveNumberFromProps(current) + patientCounters.blockNerveNumberFromProps2(current);
      const previousCount =
        patientCounters.blockNerveNumberFromProps(previous) + patientCounters.blockNerveNumberFromProps2(previous);
      return currentCount > previousCount;
    },
    description: 'Block nerve procedure needed',
  },
  {
    id: 'help',
    soundFile: help,
    configFlag: 'helpSound',
    condition: (current, previous) =>
      patientCounters.helpNumberFromProps(current) > patientCounters.helpNumberFromProps(previous),
    description: 'Help needed in OR',
  },
  {
    id: 'readyToSeeFamily',
    soundFile: waitingReady,
    configFlag: 'pacuReadySound',
    condition: (current, previous) => {
      const currentCount = pacuNumberFromProps(current) + postOpsNumberFromProps(current);
      const previousCount = pacuNumberFromProps(previous) + postOpsNumberFromProps(previous);
      return currentCount > previousCount;
    },
    description: 'Patient ready to see family',
  },
  {
    id: 'familyHere',
    soundFile: waitingReady,
    configFlag: 'waitingReadySound',
    condition: (current, previous) =>
      patientCounters.familyHereNumberFromProps(current) > patientCounters.familyHereNumberFromProps(previous),
    description: 'Family has arrived',
  },
  {
    id: 'readyToPickup',
    soundFile: readyToPickup,
    configFlag: 'readyToPickupSound',
    condition: (current, previous) =>
      patientCounters.readyToPickupNumberFromProps(current) > patientCounters.readyToPickupNumberFromProps(previous),
    description: 'Patient ready for pickup',
  },
  {
    id: 'discharge',
    soundFile: discharge,
    configFlag: 'dischargeSound',
    condition: (current, previous) =>
      patientCounters.patientNumberFromProps(current) < patientCounters.patientNumberFromProps(previous),
    description: 'Patient discharged',
  },
  {
    id: 'procedureEnd',
    soundFile: procedureEnd,
    configFlag: 'procedureEndSound',
    condition: (current, previous) =>
      patientCounters.procedureEndProps(current) > patientCounters.procedureEndProps(previous),
    description: 'Procedure ended',
  },
  {
    id: 'closing',
    soundFile: closing,
    configFlag: 'closingSound',
    condition: (current, previous) => patientCounters.closingProps(current) > patientCounters.closingProps(previous),
    description: 'Room closing',
  },
];
